class PdpMainProductNewPage extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.isBusy = false;
    this.variants = this.parseVariants();
    this.buyWidgetConfig = this.parseBuyWidgetConfig();
    this.currentVariantId = parseInt(this.dataset.initialVariantId || '', 10);
    this.currentVariant = this.variants.find((variant) => variant.id === this.currentVariantId) || this.variants[0] || null;
    this.selectedOptions = this.getVariantOptions(this.currentVariant);

    this.galleryRoot = this.querySelector('[data-gallery]');
    this.mainGallery = this.querySelector('[data-gallery-main]');
    this.thumbsGallery = this.querySelector('[data-gallery-thumbs]');
    this.thumbsScroller = this.querySelector('.pdp-main-product-new-page__gallery-thumbs-list');
    this.thumbPrevButton = this.querySelector('[data-gallery-thumbs-prev]');
    this.thumbNextButton = this.querySelector('[data-gallery-thumbs-next]');
    this.prevButton = this.querySelector('[data-gallery-prev]');
    this.nextButton = this.querySelector('[data-gallery-next]');
    this.thumbButtons = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    this.galleryPlayButtons = Array.from(this.querySelectorAll('[data-gallery-video-play]'));
    this.galleryVideos = Array.from(this.querySelectorAll('[data-gallery-slide] video'));
    this.optionButtons = Array.from(this.querySelectorAll('[data-option-button]'));
    this.optionValueOutputs = Array.from(this.querySelectorAll('[data-selected-option-value]'));
    this.currentVariantInputs = Array.from(this.querySelectorAll('[data-current-variant-id]'));
    this.currentQuantityInputs = Array.from(this.querySelectorAll('[data-current-quantity]'));
    this.priceCurrentOutputs = Array.from(this.querySelectorAll('[data-price-current]'));
    this.priceCompareOutputs = Array.from(this.querySelectorAll('[data-price-compare]'));
    this.paymentTermsRegions = Array.from(this.querySelectorAll('[data-pdp-payment-terms]'));
    this.stockIndicators = Array.from(this.querySelectorAll('[data-stock-indicator]'));
    this.reviewScrollTriggers = Array.from(this.querySelectorAll('[data-pdp-reviews-scroll]'));
    this.accordionItems = Array.from(this.querySelectorAll('[data-accordion-item]'));
    this.allowMultipleAccordions = this.dataset.allowMultipleAccordions === 'true';
    this.buyButtonsBlock = this.querySelector('[data-buy-buttons-block]');
    this.addToCartButton = this.querySelector('[data-pdp-add-to-cart]');
    this.buyNowButton = this.querySelector('[data-pdp-buy-now]');
    this.quantityInput = this.querySelector('[data-quantity-input]');
    this.quantityDecreaseButton = this.querySelector('[data-quantity-decrease]');
    this.quantityIncreaseButton = this.querySelector('[data-quantity-increase]');
    this.householdOptionButtons = Array.from(this.querySelectorAll('[data-pdp-household-option]'));
    this.planOptionButtons = Array.from(this.querySelectorAll('[data-pdp-plan-option]'));
    this.currentSellingPlanInputs = Array.from(this.querySelectorAll('[data-current-selling-plan]'));
    this.summaryCartridgeLine = this.querySelector('[data-pdp-summary-cartridge-line]');
    this.summaryCartridgePrice = this.querySelector('[data-pdp-summary-cartridge-price]');
    this.summaryDiscount = this.querySelector('[data-pdp-summary-discount]');
    this.summaryTotalCompare = this.querySelector('[data-pdp-summary-total-compare]');
    this.summaryTotalPrice = this.querySelector('[data-pdp-summary-total-price]');
    this.stickyBar = this.querySelector('[data-pdp-sticky-bar]');
    this.stickyAddToCartButton = this.querySelector('[data-pdp-sticky-add-to-cart]');
    this.stickyPriceCurrentOutput = this.querySelector('[data-pdp-sticky-price-current]');
    this.stickyPriceCompareOutput = this.querySelector('[data-pdp-sticky-price-compare]');
    this.stickyVariantOutput = this.querySelector('[data-pdp-sticky-variant]');
    this.stickyMedia = this.querySelector('.pdp-main-product-new-page__sticky-media');
    this.stickyImage = this.querySelector('[data-pdp-sticky-image]');
    this.addonItems = Array.from(this.querySelectorAll('[data-addon-item]'));
    this.addonShowMoreButtons = Array.from(this.querySelectorAll('[data-addon-show-more]'));
    this.addonToggleInputs = Array.from(this.querySelectorAll('[data-addon-toggle]'));
    this.addonQuantityInputs = Array.from(this.querySelectorAll('[data-addon-quantity-input]'));
    this.addonQuantityDecreaseButtons = Array.from(this.querySelectorAll('[data-addon-quantity-decrease]'));
    this.addonQuantityIncreaseButtons = Array.from(this.querySelectorAll('[data-addon-quantity-increase]'));
    this.sizeGuideOpenButtons = Array.from(this.querySelectorAll('[data-size-guide-open]'));
    this.sizeGuideModal = this.querySelector('[data-size-guide-modal]');
    this.sizeGuideModalPanel = this.querySelector('[data-size-guide-modal-panel]');
    this.sizeGuideModalCloseButtons = Array.from(this.querySelectorAll('[data-close-size-guide-modal]'));
    this.addonOpenButtons = Array.from(this.querySelectorAll('[data-addon-open-modal]'));
    this.addonModal = this.querySelector('[data-addon-modal]');
    this.addonModalPanel = this.querySelector('[data-addon-modal-panel]');
    this.addonModalCloseButtons = Array.from(this.querySelectorAll('[data-close-addon-modal]'));
    this.addonModalImage = this.querySelector('[data-addon-modal-image]');
    this.addonModalTitle = this.querySelector('[data-addon-modal-title]');
    this.addonModalPrice = this.querySelector('[data-addon-modal-price]');
    this.addonModalComparePrice = this.querySelector('[data-addon-modal-compare-price]');
    this.addonModalDiscountBadge = this.querySelector('[data-addon-modal-discount-badge]');
    this.addonModalOptions = this.querySelector('[data-addon-modal-options]');
    this.addonModalApplyButton = this.querySelector('[data-addon-modal-apply]');
    this.addonModalError = this.querySelector('[data-addon-modal-error]');
    this.errorRegion = this.querySelector('[data-pdp-error]');
    this.testimonialSwipers = [];
    this.addonProducts = this.parseAddonProducts();
    this.linkedAddonVariantIds = this.parseLinkedAddonVariantIds();

    this.onOptionClick = this.handleOptionClick.bind(this);
    this.onReviewScrollClick = this.handleReviewScrollClick.bind(this);
    this.onAccordionClick = this.handleAccordionClick.bind(this);
    this.onResize = this.handleResize.bind(this);
    this.onThumbClick = this.handleThumbClick.bind(this);
    this.onThumbNavClick = this.handleThumbNavClick.bind(this);
    this.onThumbsScroll = this.updateThumbNavState.bind(this);
    this.onGalleryPlayClick = this.handleGalleryPlayClick.bind(this);
    this.onGalleryVideoPlay = this.handleGalleryVideoPlay.bind(this);
    this.onGalleryVideoPause = this.handleGalleryVideoPause.bind(this);
    this.onQuantityStepClick = this.handleQuantityStepClick.bind(this);
    this.onQuantityInput = this.handleQuantityInput.bind(this);
    this.onHouseholdOptionClick = this.handleHouseholdOptionClick.bind(this);
    this.onPlanOptionClick = this.handlePlanOptionClick.bind(this);
    this.onStickyAddToCartClick = this.handleStickyAddToCartClick.bind(this);
    this.onAddonToggleChange = this.handleAddonToggleChange.bind(this);
    this.onAddonShowMoreClick = this.handleAddonShowMoreClick.bind(this);
    this.onAddonQuantityStepClick = this.handleAddonQuantityStepClick.bind(this);
    this.onAddonQuantityInput = this.handleAddonQuantityInput.bind(this);
    this.onSizeGuideOpenClick = this.handleSizeGuideOpenClick.bind(this);
    this.onSizeGuideCloseClick = this.closeSizeGuideModal.bind(this);
    this.onAddonOpenModalClick = this.handleAddonOpenModalClick.bind(this);
    this.onAddonCloseModalClick = this.closeAddonModal.bind(this);
    this.onAddonModalOptionClick = this.handleAddonModalOptionClick.bind(this);
    this.onAddonModalApplyClick = this.handleAddonModalApplyClick.bind(this);
    this.onAddToCartClick = this.handleAddToCartClick.bind(this);
    this.onBuyNowClick = this.handleBuyNowClick.bind(this);
    this.onWindowKeydown = this.handleWindowKeydown.bind(this);

    this.optionButtons.forEach((button) => button.addEventListener('click', this.onOptionClick));
    this.thumbButtons.forEach((button) => button.addEventListener('click', this.onThumbClick));
    this.thumbPrevButton?.addEventListener('click', this.onThumbNavClick);
    this.thumbNextButton?.addEventListener('click', this.onThumbNavClick);
    this.thumbsScroller?.addEventListener('scroll', this.onThumbsScroll, { passive: true });
    this.galleryPlayButtons.forEach((button) => button.addEventListener('click', this.onGalleryPlayClick));
    this.galleryVideos.forEach((video) => {
      video.addEventListener('play', this.onGalleryVideoPlay);
      video.addEventListener('pause', this.onGalleryVideoPause);
      video.addEventListener('ended', this.onGalleryVideoPause);
    });
    this.reviewScrollTriggers.forEach((trigger) => trigger.addEventListener('click', this.onReviewScrollClick));
    this.accordionItems.forEach((item) => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      trigger?.addEventListener('click', this.onAccordionClick);
    });
    this.quantityDecreaseButton?.addEventListener('click', this.onQuantityStepClick);
    this.quantityIncreaseButton?.addEventListener('click', this.onQuantityStepClick);
    this.quantityInput?.addEventListener('input', this.onQuantityInput);
    this.quantityInput?.addEventListener('blur', this.onQuantityInput);
    this.householdOptionButtons.forEach((button) => button.addEventListener('click', this.onHouseholdOptionClick));
    this.planOptionButtons.forEach((button) => button.addEventListener('click', this.onPlanOptionClick));
    this.stickyAddToCartButton?.addEventListener('click', this.onStickyAddToCartClick);
    this.addonToggleInputs.forEach((input) => input.addEventListener('change', this.onAddonToggleChange));
    this.addonShowMoreButtons.forEach((button) => button.addEventListener('click', this.onAddonShowMoreClick));
    this.addonQuantityDecreaseButtons.forEach((button) => button.addEventListener('click', this.onAddonQuantityStepClick));
    this.addonQuantityIncreaseButtons.forEach((button) => button.addEventListener('click', this.onAddonQuantityStepClick));
    this.addonQuantityInputs.forEach((input) => {
      input.addEventListener('input', this.onAddonQuantityInput);
      input.addEventListener('blur', this.onAddonQuantityInput);
    });
    this.sizeGuideOpenButtons.forEach((button) => button.addEventListener('click', this.onSizeGuideOpenClick));
    this.sizeGuideModalCloseButtons.forEach((button) => button.addEventListener('click', this.onSizeGuideCloseClick));
    this.addonOpenButtons.forEach((button) => button.addEventListener('click', this.onAddonOpenModalClick));
    this.addonModalCloseButtons.forEach((button) => button.addEventListener('click', this.onAddonCloseModalClick));
    this.addonModalOptions?.addEventListener('click', this.onAddonModalOptionClick);
    this.addonModalApplyButton?.addEventListener('click', this.onAddonModalApplyClick);
    this.addToCartButton?.addEventListener('click', this.onAddToCartClick);
    this.buyNowButton?.addEventListener('click', this.onBuyNowClick);

    this.setupAccordions();
    this.setupGallery();
    this.setupTestimonials();
    this.setupStickyBar();
    this.syncVariantUI({ syncGallery: false });
    this.updateAddonShowMoreButtons();
    window.addEventListener('resize', this.onResize);
    window.addEventListener('keydown', this.onWindowKeydown);
  }

  disconnectedCallback() {
    this.optionButtons?.forEach((button) => button.removeEventListener('click', this.onOptionClick));
    this.thumbButtons?.forEach((button) => button.removeEventListener('click', this.onThumbClick));
    this.thumbPrevButton?.removeEventListener('click', this.onThumbNavClick);
    this.thumbNextButton?.removeEventListener('click', this.onThumbNavClick);
    this.thumbsScroller?.removeEventListener('scroll', this.onThumbsScroll);
    this.galleryPlayButtons?.forEach((button) => button.removeEventListener('click', this.onGalleryPlayClick));
    this.galleryVideos?.forEach((video) => {
      video.removeEventListener('play', this.onGalleryVideoPlay);
      video.removeEventListener('pause', this.onGalleryVideoPause);
      video.removeEventListener('ended', this.onGalleryVideoPause);
    });
    this.reviewScrollTriggers?.forEach((trigger) => trigger.removeEventListener('click', this.onReviewScrollClick));
    this.accordionItems?.forEach((item) => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      trigger?.removeEventListener('click', this.onAccordionClick);
    });
    this.quantityDecreaseButton?.removeEventListener('click', this.onQuantityStepClick);
    this.quantityIncreaseButton?.removeEventListener('click', this.onQuantityStepClick);
    this.quantityInput?.removeEventListener('input', this.onQuantityInput);
    this.quantityInput?.removeEventListener('blur', this.onQuantityInput);
    this.householdOptionButtons?.forEach((button) => button.removeEventListener('click', this.onHouseholdOptionClick));
    this.planOptionButtons?.forEach((button) => button.removeEventListener('click', this.onPlanOptionClick));
    this.stickyAddToCartButton?.removeEventListener('click', this.onStickyAddToCartClick);
    this.addonToggleInputs?.forEach((input) => input.removeEventListener('change', this.onAddonToggleChange));
    this.addonShowMoreButtons?.forEach((button) => button.removeEventListener('click', this.onAddonShowMoreClick));
    this.addonQuantityDecreaseButtons?.forEach((button) =>
      button.removeEventListener('click', this.onAddonQuantityStepClick)
    );
    this.addonQuantityIncreaseButtons?.forEach((button) =>
      button.removeEventListener('click', this.onAddonQuantityStepClick)
    );
    this.addonQuantityInputs?.forEach((input) => {
      input.removeEventListener('input', this.onAddonQuantityInput);
      input.removeEventListener('blur', this.onAddonQuantityInput);
    });
    this.sizeGuideOpenButtons?.forEach((button) => button.removeEventListener('click', this.onSizeGuideOpenClick));
    this.sizeGuideModalCloseButtons?.forEach((button) =>
      button.removeEventListener('click', this.onSizeGuideCloseClick)
    );
    this.addonOpenButtons?.forEach((button) => button.removeEventListener('click', this.onAddonOpenModalClick));
    this.addonModalCloseButtons?.forEach((button) => button.removeEventListener('click', this.onAddonCloseModalClick));
    this.addonModalOptions?.removeEventListener('click', this.onAddonModalOptionClick);
    this.addonModalApplyButton?.removeEventListener('click', this.onAddonModalApplyClick);
    this.addToCartButton?.removeEventListener('click', this.onAddToCartClick);
    this.buyNowButton?.removeEventListener('click', this.onBuyNowClick);

    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('keydown', this.onWindowKeydown);
    this.buyButtonsObserver?.disconnect();
    this.footerObserver?.disconnect();
    this.mainSwiper?.destroy(true, true);
    this.testimonialSwipers?.forEach((swiper) => swiper.destroy(true, true));
    this.testimonialSwipers = [];
  }

  parseVariants() {
    const variantsScript = this.querySelector('[data-variants-json]');
    if (!variantsScript) return [];

    try {
      const parsed = JSON.parse(variantsScript.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  parseBuyWidgetConfig() {
    const configScript = this.querySelector('[data-buy-widget-config-json]');
    if (!configScript) return null;

    try {
      const parsed = JSON.parse(configScript.textContent || '{}');
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  parseAddonProducts() {
    const products = {};
    const scripts = this.querySelectorAll('[data-addon-product-json]');

    scripts.forEach((script) => {
      const key = script.dataset.addonProductKey;
      if (!key) return;

      try {
        products[key] = JSON.parse(script.textContent || '{}');
      } catch (error) {
        console.error(error);
      }
    });

    return products;
  }

  parseLinkedAddonVariantIds() {
    const ids = new Set();
    const blocks = this.querySelectorAll('[data-linked-addon-variant-ids]');

    blocks.forEach((block) => {
      const value = block instanceof HTMLElement ? block.dataset.linkedAddonVariantIds || '' : '';
      const matches = value.match(/\d+/g) || [];

      matches.forEach((id) => ids.add(id));
    });

    return ids;
  }

  getVariantOptions(variant) {
    if (!variant) return [];

    return [variant.option1, variant.option2, variant.option3].filter((value) => value !== null && value !== undefined);
  }

  setupGallery() {
    if (!(this.mainGallery instanceof HTMLElement) || typeof window.Swiper !== 'function') return;

    this.mainSwiper?.destroy(true, true);

    this.mainSwiper = new window.Swiper(this.mainGallery, {
      initialSlide: 0,
      slidesPerView: 1,
      speed: 500,
      spaceBetween: 12,
      preventClicks: false,
      preventClicksPropagation: false,
      touchStartPreventDefault: false,
      noSwipingSelector: 'video, iframe, .pdp-main-product-new-page__gallery-video-shell',
      navigation:
        this.prevButton instanceof HTMLElement && this.nextButton instanceof HTMLElement
          ? {
              prevEl: this.prevButton,
              nextEl: this.nextButton,
            }
          : undefined,
      on: {
        slideChange: () => {
          this.syncActiveThumbByIndex(this.mainSwiper?.activeIndex || 0);
          this.pauseInactiveGalleryMedia();
        },
        slideChangeTransitionEnd: () => {
          if (!this.pendingGalleryPlayMediaId) return;

          const activeSlide = this.getActiveGallerySlide();
          const activeMediaId = Number(activeSlide?.dataset.mediaId || '');

          if (activeMediaId === this.pendingGalleryPlayMediaId) {
            this.playGalleryMediaInSlide(activeSlide);
          }

          this.pendingGalleryPlayMediaId = null;
        },
      },
    });

    this.mainSwiper.slideTo(0, 0, false);
    this.syncActiveThumbByIndex(0, { scrollThumbs: false });
    this.pauseInactiveGalleryMedia();
    this.updateThumbNavState();
  }

  setupTestimonials() {
    this.testimonialSwipers?.forEach((swiper) => swiper.destroy(true, true));
    this.testimonialSwipers = [];

    if (typeof window.Swiper !== 'function') return;

    this.querySelectorAll('[data-testimonials-slider]').forEach((slider) => {
      if (!(slider instanceof HTMLElement)) return;

      const slidesCount = slider.querySelectorAll('.swiper-slide').length;
      const pagination = slider.parentElement?.querySelector('[data-testimonials-pagination]');

      const swiper = new window.Swiper(slider, {
        slidesPerView: 1,
        speed: 450,
        autoHeight: true,
        spaceBetween: 12,
        allowTouchMove: slidesCount > 1,
        loop: slidesCount > 1,
        pagination:
          pagination instanceof HTMLElement && slidesCount > 1
            ? {
                el: pagination,
                clickable: true,
              }
            : undefined,
      });

      this.testimonialSwipers.push(swiper);
    });
  }

  setupStickyBar() {
    if (!(this.stickyBar instanceof HTMLElement) || !(this.buyButtonsBlock instanceof HTMLElement)) return;

    const footer = document.querySelector('footer') ?? document.querySelector('[class*="footer-group"]');
    if (!(footer instanceof HTMLElement)) return;

    this.buyButtonsObserver?.disconnect();
    this.footerObserver?.disconnect();
    this.stickyHiddenByBottom = false;

    this.buyButtonsObserver = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (!entry) return;

      const hasScrolledPastBuyButtons = entry.boundingClientRect.bottom < 0 || entry.boundingClientRect.top < 0;

      if (!entry.isIntersecting && hasScrolledPastBuyButtons && !this.stickyHiddenByBottom) {
        this.showStickyBar();
        return;
      }

      if (entry.isIntersecting) {
        this.stickyHiddenByBottom = false;
        this.hideStickyBar();
      }
    });

    this.footerObserver = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (!entry) return;

        if (entry.isIntersecting) {
          this.stickyHiddenByBottom = true;
          this.hideStickyBar();
          return;
        }

        const buyButtonsRect = this.buyButtonsBlock.getBoundingClientRect();
        const hasScrolledPastBuyButtons = buyButtonsRect.bottom < 0 || buyButtonsRect.top < 0;

        if (this.stickyHiddenByBottom && hasScrolledPastBuyButtons) {
          this.stickyHiddenByBottom = false;
          this.showStickyBar();
        }
      },
      {
        rootMargin: '200px 0px 0px 0px',
      }
    );

    this.buyButtonsObserver.observe(this.buyButtonsBlock);
    this.footerObserver.observe(footer);
  }

  handleResize() {
    if (this.mainSwiper) {
      const activeIndex = this.mainSwiper.activeIndex || 0;
      this.mainSwiper.update();
      this.mainSwiper.slideTo(activeIndex, 0, false);
      this.syncActiveThumbByIndex(activeIndex);
      this.updateThumbNavState();
    }

    this.testimonialSwipers?.forEach((swiper) => swiper.update());

    this.accordionItems.forEach((item) => {
      if (!item.classList.contains('is-open')) return;

      const panel = item.querySelector('[data-accordion-panel]');
      const inner = item.querySelector('[data-accordion-inner]');
      if (!(panel instanceof HTMLElement) || !(inner instanceof HTMLElement)) return;

      panel.style.height = `${inner.offsetHeight}px`;
      requestAnimationFrame(() => {
        if (item.classList.contains('is-open')) {
          panel.style.height = 'auto';
        }
      });
    });
  }

  handleThumbClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    const mediaId = parseInt(button.dataset.mediaId || '', 10);
    if (Number.isNaN(mediaId)) return;

    this.slideToMedia(mediaId, { play: true });
  }

  handleThumbNavClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const direction = button.hasAttribute('data-gallery-thumbs-prev') ? -1 : 1;
    this.scrollThumbsByDirection(direction);
  }

  scrollThumbsByDirection(direction) {
    const scroller = this.thumbsScroller;
    if (!(scroller instanceof HTMLElement)) return;

    const isVertical = this.isThumbScrollerVertical();
    const distance = Math.max(1, isVertical ? scroller.clientHeight : scroller.clientWidth) * 0.8;

    scroller.scrollBy({
      [isVertical ? 'top' : 'left']: distance * direction,
      behavior: 'smooth',
    });
  }

  isThumbScrollerVertical() {
    return (
      this.thumbsGallery instanceof HTMLElement &&
      this.thumbsGallery.dataset.desktopDirection === 'vertical' &&
      window.matchMedia('(min-width: 750px)').matches
    );
  }

  updateThumbNavState() {
    const scroller = this.thumbsScroller;
    if (!(scroller instanceof HTMLElement)) return;

    const isVertical = this.isThumbScrollerVertical();
    const scrollPosition = isVertical ? scroller.scrollTop : scroller.scrollLeft;
    const scrollSize = isVertical ? scroller.scrollHeight : scroller.scrollWidth;
    const clientSize = isVertical ? scroller.clientHeight : scroller.clientWidth;
    const maxScroll = Math.max(0, scrollSize - clientSize);
    const hasOverflow = maxScroll > 2;

    if (this.thumbPrevButton instanceof HTMLButtonElement) {
      this.thumbPrevButton.disabled = !hasOverflow || scrollPosition <= 1;
    }

    if (this.thumbNextButton instanceof HTMLButtonElement) {
      this.thumbNextButton.disabled = !hasOverflow || scrollPosition >= maxScroll - 1;
    }
  }

  handleGalleryPlayClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const button = event.currentTarget;
    const slide = button instanceof HTMLElement ? button.closest('[data-gallery-slide]') : null;

    if (!(slide instanceof HTMLElement)) return;

    const mediaId = Number.parseInt(slide.dataset.mediaId || '', 10);
    const activeSlide = this.getActiveGallerySlide();

    if (!Number.isNaN(mediaId) && activeSlide !== slide) {
      this.slideToMedia(mediaId, { play: true });
      return;
    }

    this.playGalleryMediaInSlide(slide);
  }

  handleGalleryVideoPlay(event) {
    const video = event.currentTarget;
    const slide = video instanceof HTMLElement ? video.closest('[data-gallery-slide]') : null;

    if (slide instanceof HTMLElement) {
      this.setGalleryVideoOverlayState(slide, true);
    }
  }

  handleGalleryVideoPause(event) {
    const video = event.currentTarget;
    const slide = video instanceof HTMLElement ? video.closest('[data-gallery-slide]') : null;

    if (slide instanceof HTMLElement) {
      this.setGalleryVideoOverlayState(slide, false);
    }
  }

  handleOptionClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const optionIndex = parseInt(button.dataset.optionIndex || '', 10);
    const optionValue = button.dataset.optionValue || '';
    if (Number.isNaN(optionIndex)) return;

    this.selectedOptions[optionIndex] = optionValue;

    const matchedVariant = this.findVariantBySelections(this.selectedOptions);
    if (matchedVariant) {
      this.currentVariant = matchedVariant;
      this.currentVariantId = matchedVariant.id;
      this.selectedOptions = this.getVariantOptions(matchedVariant);
    }

    this.syncVariantUI();
  }

  findVariantBySelections(selections) {
    const exactAvailable = this.variants.find((variant) => variant.available && this.matchesSelections(variant, selections));
    if (exactAvailable) return exactAvailable;

    return this.variants.find((variant) => this.matchesSelections(variant, selections)) || null;
  }

  matchesSelections(variant, selections) {
    const variantOptions = this.getVariantOptions(variant);

    for (let index = 0; index < selections.length; index += 1) {
      const selectedValue = selections[index];
      if (!selectedValue) continue;
      if (variantOptions[index] !== selectedValue) return false;
    }

    return true;
  }

  syncVariantUI({ syncGallery = true } = {}) {
    const buttonsByGroup = new Map();

    this.optionButtons.forEach((button) => {
      const optionIndex = parseInt(button.dataset.optionIndex || '', 10);
      if (Number.isNaN(optionIndex)) return;

      if (!buttonsByGroup.has(optionIndex)) {
        buttonsByGroup.set(optionIndex, []);
      }
      buttonsByGroup.get(optionIndex).push(button);
    });

    buttonsByGroup.forEach((buttons, optionIndex) => {
      buttons.forEach((button) => {
        const testSelections = [...this.selectedOptions];
        testSelections[optionIndex] = button.dataset.optionValue || '';

        const matchingVariant = this.variants.find(
          (variant) => variant.available && this.matchesSelections(variant, testSelections)
        );

        button.disabled = !matchingVariant;
        button.classList.toggle('is-active', this.selectedOptions[optionIndex] === button.dataset.optionValue);
      });
    });

    this.optionValueOutputs.forEach((output) => {
      const optionIndex = parseInt(output.dataset.selectedOptionValue || '', 10);
      if (Number.isNaN(optionIndex)) return;

      output.textContent = this.selectedOptions[optionIndex] || '';
    });

    this.syncProductFormInputs({ dispatchChange: true });

    this.syncPriceOutputs();

    this.stockIndicators.forEach((indicator) => {
      if (!(indicator instanceof HTMLElement)) return;

      const stockElement = indicator.querySelector('.pdp-main-product-new-page__stock-inline');
      const textElement = indicator.querySelector('[data-stock-text]');
      const showQuantity = indicator.dataset.showQuantity === 'true';
      const lowStockThreshold = parseInt(indicator.dataset.lowStockThreshold || '5', 10);
      const inStockLabel = indicator.dataset.inStockLabel || 'In stock';
      const lowStockPrefix = indicator.dataset.lowStockPrefix || 'Only';
      const lowStockSuffix = indicator.dataset.lowStockSuffix || 'left in stock';
      const outOfStockLabel = indicator.dataset.outOfStockLabel || 'Out of stock';
      const supportText = indicator.dataset.supportText || inStockLabel;

      if (!(stockElement instanceof HTMLElement) || !(textElement instanceof HTMLElement)) return;

      let state = 'in-stock';
      let text = supportText;

      if (!this.currentVariant || !this.currentVariant.available) {
        state = 'out-of-stock';
        text = outOfStockLabel;
      } else if (
        this.currentVariant.inventory_management &&
        typeof this.currentVariant.inventory_quantity === 'number' &&
        this.currentVariant.inventory_quantity > 0 &&
        this.currentVariant.inventory_quantity <= lowStockThreshold
      ) {
        state = 'low-stock';
        text = showQuantity
          ? `${lowStockPrefix} ${this.currentVariant.inventory_quantity} ${lowStockSuffix}`.trim()
          : supportText;
      }

      stockElement.classList.remove(
        'pdp-main-product-new-page__stock-inline--in-stock',
        'pdp-main-product-new-page__stock-inline--low-stock',
        'pdp-main-product-new-page__stock-inline--out-of-stock'
      );
      stockElement.classList.add(`pdp-main-product-new-page__stock-inline--${state}`);
      textElement.textContent = text;
    });

    if (syncGallery && this.currentVariant?.featured_media_id) {
      this.slideToMedia(this.currentVariant.featured_media_id);
    }

    this.clearError();
    this.syncPurchaseUI();
  }

  syncActiveThumbByIndex(index, { scrollThumbs = true } = {}) {
    const slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
    const activeSlide = slides[index];
    const mediaId = parseInt(activeSlide?.dataset.mediaId || '', 10);

    this.thumbButtons.forEach((thumbButton, thumbIndex) => {
      const isActive = thumbIndex === index || Number(thumbButton.dataset.mediaId) === mediaId;
      thumbButton.classList.toggle('is-active', isActive);
      thumbButton.setAttribute('aria-current', isActive ? 'true' : 'false');

      if (isActive && scrollThumbs) {
        this.scrollThumbIntoView(thumbButton);
      }
    });
  }

  scrollThumbIntoView(thumbButton) {
    if (!(thumbButton instanceof HTMLElement) || !(this.thumbsGallery instanceof HTMLElement)) return;

    const scroller = this.thumbsGallery.querySelector('.pdp-main-product-new-page__gallery-thumbs-list');
    const thumbSlide = thumbButton.closest('.pdp-main-product-new-page__gallery-thumb-slide');

    if (!(scroller instanceof HTMLElement) || !(thumbSlide instanceof HTMLElement)) return;

    const isVertical = scroller.scrollHeight > scroller.clientHeight + 4;
    const padding = 12;

    if (isVertical) {
      const thumbTop = thumbSlide.offsetTop;
      const thumbBottom = thumbTop + thumbSlide.offsetHeight;
      const viewportTop = scroller.scrollTop;
      const viewportBottom = viewportTop + scroller.clientHeight;

      if (thumbTop < viewportTop) {
        scroller.scrollTo({ top: Math.max(thumbTop - padding, 0), behavior: 'smooth' });
      } else if (thumbBottom > viewportBottom) {
        scroller.scrollTo({
          top: thumbBottom - scroller.clientHeight + padding,
          behavior: 'smooth',
        });
      }

      return;
    }

    const thumbLeft = thumbSlide.offsetLeft;
    const thumbRight = thumbLeft + thumbSlide.offsetWidth;
    const viewportLeft = scroller.scrollLeft;
    const viewportRight = viewportLeft + scroller.clientWidth;

    if (thumbLeft < viewportLeft) {
      scroller.scrollTo({ left: Math.max(thumbLeft - padding, 0), behavior: 'smooth' });
    } else if (thumbRight > viewportRight) {
      scroller.scrollTo({
        left: thumbRight - scroller.clientWidth + padding,
        behavior: 'smooth',
      });
    }
  }

  slideToMedia(mediaId, { play = false } = {}) {
    const slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
    const targetIndex = slides.findIndex((slide) => Number(slide.dataset.mediaId) === Number(mediaId));

    if (targetIndex < 0) return;

    if (this.mainSwiper) {
      this.mainSwiper.slideTo(targetIndex);
    }

    this.syncActiveThumbByIndex(targetIndex);

    if (play) {
      this.pendingGalleryPlayMediaId = Number(mediaId);
      this.playGalleryMediaInSlide(slides[targetIndex]);
    }
  }

  getActiveGallerySlide() {
    const slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
    return slides[this.mainSwiper?.activeIndex || 0] || null;
  }

  playGalleryMediaInSlide(slide) {
    if (!(slide instanceof HTMLElement)) return;

    const video = slide.querySelector('video');
    if (video instanceof HTMLVideoElement && typeof video.play === 'function') {
      this.setGalleryVideoOverlayState(slide, true);
      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          this.setGalleryVideoOverlayState(slide, false);
        });
      }
    }

    const iframes = Array.from(slide.querySelectorAll('iframe'));

    iframes.forEach((iframe) => this.playEmbeddedGalleryVideo(iframe));

    if (iframes.length > 0) {
      this.setGalleryVideoOverlayState(slide, true);
    }
  }

  pauseInactiveGalleryMedia() {
    const slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
    const activeIndex = this.mainSwiper?.activeIndex || 0;

    slides.forEach((slide, index) => {
      if (index === activeIndex) return;

      slide.querySelectorAll('video').forEach((video) => {
        if (typeof video.pause === 'function') {
          video.pause();
        }
      });

      slide.querySelectorAll('iframe').forEach((iframe) => this.pauseEmbeddedGalleryVideo(iframe));
      this.setGalleryVideoOverlayState(slide, false);
    });
  }

  playEmbeddedGalleryVideo(iframe) {
    if (!(iframe instanceof HTMLIFrameElement) || !iframe.contentWindow) return;

    const source = iframe.src || '';
    const autoplaySource = this.withEmbedParam(source, 'autoplay', '1');

    if (autoplaySource && autoplaySource !== source) {
      iframe.src = autoplaySource;
    }

    if (source.includes('youtube.com') || source.includes('youtube-nocookie.com')) {
      iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    } else if (source.includes('vimeo.com')) {
      iframe.contentWindow.postMessage({ method: 'play' }, '*');
    }
  }

  pauseEmbeddedGalleryVideo(iframe) {
    if (!(iframe instanceof HTMLIFrameElement) || !iframe.contentWindow) return;

    const source = iframe.src || '';

    if (source.includes('youtube.com') || source.includes('youtube-nocookie.com')) {
      iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    } else if (source.includes('vimeo.com')) {
      iframe.contentWindow.postMessage({ method: 'pause' }, '*');
    }
  }

  withEmbedParam(source, name, value) {
    if (!source) return source;

    try {
      const url = new URL(source, window.location.href);
      url.searchParams.set(name, value);

      return url.toString();
    } catch (error) {
      const separator = source.includes('?') ? '&' : '?';
      return `${source}${separator}${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
    }
  }

  setGalleryVideoOverlayState(slide, isPlaying) {
    if (!(slide instanceof HTMLElement)) return;

    slide.classList.toggle('is-video-playing', isPlaying);
    slide.querySelectorAll('[data-gallery-video-play]').forEach((button) => {
      if (button instanceof HTMLElement) {
        button.hidden = isPlaying;
      }
    });
  }

  setupAccordions() {
    this.accordionItems.forEach((item) => {
      const panel = item.querySelector('[data-accordion-panel]');
      const inner = item.querySelector('[data-accordion-inner]');
      const isOpen = item.dataset.openDefault === 'true';

      if (!(panel instanceof HTMLElement) || !(inner instanceof HTMLElement)) return;

      if (isOpen) {
        item.classList.add('is-open');
        panel.style.height = 'auto';
      } else {
        item.classList.remove('is-open');
        panel.style.height = '0px';
      }
    });
  }

  handleReviewScrollClick(event) {
    event.preventDefault();

    const trigger = event.currentTarget;
    if (!(trigger instanceof HTMLElement)) return;

    const target = this.findReviewsTarget(trigger);

    if (target) {
      this.scrollToReviewsTarget(target);
      return;
    }

    const href = trigger.getAttribute('href');
    if (href?.startsWith('#')) {
      window.location.hash = href;
    }
  }

  findReviewsTarget(trigger) {
    const href = trigger.getAttribute('href') || '';
    const hash = href.startsWith('#') ? href.slice(1) : '';

    if (hash) {
      const explicitTarget = document.getElementById(decodeURIComponent(hash));
      if (explicitTarget instanceof HTMLElement && this.isValidReviewsTarget(trigger, explicitTarget)) {
        return explicitTarget;
      }
    }

    const selectors = [
      '#reviews',
      '#judgeme_product_reviews',
      '#shopify-product-reviews',
      '#bundle-product_reviews',
      '.jdgm-review-widget',
      '.spr-container',
      '.euroguard-customer-reviews-section',
      '.shopify-section-customer-reviews-grid',
      '.customer-reviews-scroller',
      '[data-reviews-track]'
    ];

    for (const selector of selectors) {
      const candidates = Array.from(document.querySelectorAll(selector));
      const target = candidates.find((candidate) => this.isValidReviewsTarget(trigger, candidate));

      if (target instanceof HTMLElement) {
        return target;
      }
    }

    return null;
  }

  isValidReviewsTarget(trigger, candidate) {
    if (!(candidate instanceof HTMLElement)) return false;
    if (this.contains(candidate)) return false;

    const triggerTop = trigger.getBoundingClientRect().top + window.scrollY;
    const candidateTop = candidate.getBoundingClientRect().top + window.scrollY;
    const candidateRect = candidate.getBoundingClientRect();

    return candidateTop > triggerTop + 40 && candidateRect.width > 0 && candidateRect.height > 0;
  }

  scrollToReviewsTarget(target) {
    const headerOffset = this.getScrollHeaderOffset();
    const targetTop = target.getBoundingClientRect().top + window.scrollY - headerOffset;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: prefersReducedMotion ? 'auto' : 'smooth'
    });
  }

  getScrollHeaderOffset() {
    const header = document.querySelector('header-component, sticky-header, .shopify-section-header-sticky, .shopify-section-header');

    if (!(header instanceof HTMLElement)) {
      return 88;
    }

    const style = window.getComputedStyle(header);
    const isSticky = style.position === 'sticky' || style.position === 'fixed';

    return isSticky ? Math.ceil(header.getBoundingClientRect().height + 16) : 24;
  }

  handleAccordionClick(event) {
    const trigger = event.currentTarget;
    const item = trigger?.closest('[data-accordion-item]');
    if (!(item instanceof HTMLElement)) return;

    const shouldOpen = !item.classList.contains('is-open');

    if (shouldOpen && !this.allowMultipleAccordions) {
      this.accordionItems.forEach((otherItem) => {
        if (otherItem !== item) this.closeAccordionItem(otherItem);
      });
    }

    if (shouldOpen) {
      this.openAccordionItem(item);
    } else {
      this.closeAccordionItem(item);
    }
  }

  openAccordionItem(item) {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const panel = item.querySelector('[data-accordion-panel]');
    const inner = item.querySelector('[data-accordion-inner]');

    if (!(trigger instanceof HTMLElement) || !(panel instanceof HTMLElement) || !(inner instanceof HTMLElement)) return;

    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');

    panel.style.height = `${panel.offsetHeight}px`;
    requestAnimationFrame(() => {
      panel.style.height = `${inner.offsetHeight}px`;
    });

    panel.addEventListener(
      'transitionend',
      () => {
        if (item.classList.contains('is-open')) {
          panel.style.height = 'auto';
        }
      },
      { once: true }
    );
  }

  closeAccordionItem(item) {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const panel = item.querySelector('[data-accordion-panel]');
    const inner = item.querySelector('[data-accordion-inner]');

    if (!(trigger instanceof HTMLElement) || !(panel instanceof HTMLElement) || !(inner instanceof HTMLElement)) return;

    const startHeight = panel.style.height === 'auto' ? inner.offsetHeight : panel.offsetHeight;
    panel.style.height = `${startHeight}px`;

    requestAnimationFrame(() => {
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.style.height = '0px';
    });
  }

  handleQuantityStepClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement) || !(this.quantityInput instanceof HTMLInputElement)) return;

    const currentValue = this.getQuantity();
    const delta = button.hasAttribute('data-quantity-increase') ? 1 : -1;
    const nextValue = Math.max(1, currentValue + delta);
    this.quantityInput.value = String(nextValue);
    this.syncPurchaseUI();
  }

  handleQuantityInput() {
    if (!(this.quantityInput instanceof HTMLInputElement)) return;

    const sanitizedValue = this.getQuantity();
    this.quantityInput.value = String(sanitizedValue);
    this.syncPurchaseUI();
  }

  handleHouseholdOptionClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const quantity = parseInt(button.dataset.householdQuantity || '1', 10);
    const normalizedQuantity = Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;

    this.householdOptionButtons.forEach((optionButton) => {
      const isActive = optionButton === button;
      optionButton.classList.toggle('is-active', isActive);
      optionButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (this.quantityInput instanceof HTMLInputElement) {
      this.quantityInput.value = String(this.getQuantity());
    }

    this.syncPurchaseUI();
  }

  handlePlanOptionClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    this.planOptionButtons.forEach((optionButton) => {
      const isActive = optionButton === button;
      optionButton.classList.toggle('is-active', isActive);
      optionButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (this.quantityInput instanceof HTMLInputElement) {
      this.quantityInput.value = String(this.getQuantity());
    }

    this.syncPurchaseUI();
  }

  handleStickyAddToCartClick(event) {
    event.preventDefault();
    this.addCurrentVariant({ redirectToCheckout: false });
  }

  handleAddonToggleChange() {
    this.syncPurchaseUI();
  }

  handleAddonShowMoreClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    const block = button.closest('[data-addons-block]');
    if (!(block instanceof HTMLElement)) return;

    const collapsibleItems = Array.from(block.querySelectorAll('[data-addon-collapsible="true"]'));
    if (!collapsibleItems.length) return;

    const isExpanded = block.classList.toggle('is-expanded');

    collapsibleItems.forEach((item) => {
      if (!(item instanceof HTMLElement)) return;
      item.hidden = !isExpanded;
    });

    this.updateAddonShowMoreButtons();
  }

  handleAddonQuantityStepClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    const addonItem = button.closest('[data-addon-item]');
    const input = addonItem?.querySelector('[data-addon-quantity-input]');
    if (!(input instanceof HTMLInputElement)) return;

    const currentValue = this.getNormalizedQuantityValue(input);
    const delta = button.hasAttribute('data-addon-quantity-increase') ? 1 : -1;
    const nextValue = Math.max(1, currentValue + delta);

    input.value = String(nextValue);
    this.syncPurchaseUI();
  }

  handleAddonQuantityInput(event) {
    const input = event.currentTarget;
    if (!(input instanceof HTMLInputElement)) return;

    input.value = String(this.getNormalizedQuantityValue(input));
    this.syncPurchaseUI();
  }

  handleSizeGuideOpenClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement) || !(this.sizeGuideModal instanceof HTMLElement)) return;

    this.activeSizeGuideTrigger = button;
    this.openSizeGuideModal();
  }

  handleAddonOpenModalClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    const productKey = button.dataset.addonProductKey || '';
    const addonItem = button.closest('[data-addon-item]');
    const addonProduct = productKey ? this.addonProducts[productKey] : null;

    if (!(addonItem instanceof HTMLElement) || !addonProduct || !this.hasSelectableAddonOptions(addonProduct)) return;

    this.activeAddonItem = addonItem;
    this.activeAddonProduct = addonProduct;
    this.activeAddonTrigger = button;
    this.activeAddonSelections = this.getInitialAddonSelections(addonProduct);

    this.renderAddonModal();
    this.openAddonModal();
  }

  handleAddonModalOptionClick(event) {
    const button = event.target.closest('[data-addon-option-index][data-addon-option-value]');
    if (!(button instanceof HTMLButtonElement)) return;
    if (button.getAttribute('aria-disabled') === 'true') return;

    const optionIndex = Number.parseInt(button.dataset.addonOptionIndex || '', 10);
    const optionValue = button.dataset.addonOptionValue;

    if (Number.isNaN(optionIndex) || typeof optionValue !== 'string') return;

    this.activeAddonSelections[optionIndex] = optionValue;
    this.renderAddonModal();
  }

  handleAddonModalApplyClick() {
    if (!(this.activeAddonItem instanceof HTMLElement) || !this.activeAddonProduct) return;

    const variant = this.getSelectedAddonVariant();
    if (!variant) {
      this.showAddonModalError('This combination is unavailable.');
      return;
    }

    this.applyAddonVariantToItem(this.activeAddonItem, this.activeAddonProduct, variant);
    this.closeAddonModal();
    this.syncPurchaseUI();
  }

  handleAddToCartClick(event) {
    event.preventDefault();
    this.addCurrentVariant({ redirectToCheckout: false });
  }

  handleBuyNowClick(event) {
    event.preventDefault();
    this.addCurrentVariant({ redirectToCheckout: true });
  }

  getMainOfferVariantData() {
    return this.buyWidgetConfig?.main || this.currentVariant || null;
  }

  getCartridgeVariantData() {
    return this.buyWidgetConfig?.cartridge || this.currentVariant || null;
  }

  getHouseholdQuantity() {
    const activeHousehold = this.householdOptionButtons.find((button) => button.classList.contains('is-active'));
    const parsedValue = parseInt(activeHousehold?.dataset.householdQuantity || this.quantityInput?.value || '1', 10);
    return Number.isNaN(parsedValue) || parsedValue < 1 ? 1 : parsedValue;
  }

  getPlanCartridgeMultiplier(button = this.getSelectedPlanButton()) {
    const parsedValue = parseInt(button?.dataset.planCartridgeMultiplier || '1', 10);
    return Number.isNaN(parsedValue) || parsedValue < 1 ? 1 : parsedValue;
  }

  getQuantity() {
    return Math.max(1, this.getHouseholdQuantity() * this.getPlanCartridgeMultiplier());
  }

  getNormalizedQuantityValue(input) {
    const parsedValue = parseInt(input?.value || '1', 10);
    return Number.isNaN(parsedValue) || parsedValue < 1 ? 1 : parsedValue;
  }

  getSelectedPlanButton() {
    return this.planOptionButtons.find((button) => button.classList.contains('is-active')) || this.planOptionButtons[0] || null;
  }

  hasPlanSelector() {
    return this.planOptionButtons.length > 0;
  }

  isPlanButtonAvailable(button) {
    if (!(button instanceof HTMLButtonElement)) return false;

    const sellingPlanId = (button.dataset.sellingPlanId || '').trim();
    return Boolean(sellingPlanId && this.getSellingPlanAllocation(sellingPlanId));
  }

  getSelectedSellingPlanId() {
    const planButton = this.getSelectedPlanButton();
    return (planButton?.dataset.sellingPlanId || '').trim();
  }

  getValidatedSellingPlanId() {
    const sellingPlanId = this.getSelectedSellingPlanId();
    return sellingPlanId && this.getSellingPlanAllocation(sellingPlanId) ? sellingPlanId : '';
  }

  hasValidSellingPlanSelection() {
    return !this.hasPlanSelector() || Boolean(this.getValidatedSellingPlanId());
  }

  getSellingPlanAllocation(sellingPlanId = this.getSelectedSellingPlanId()) {
    const cartridgeVariant = this.getCartridgeVariantData();

    if (!sellingPlanId || !cartridgeVariant || !Array.isArray(cartridgeVariant.selling_plan_allocations)) {
      return null;
    }

    return (
      cartridgeVariant.selling_plan_allocations.find(
        (allocation) => String(allocation.selling_plan_id) === String(sellingPlanId)
      ) || null
    );
  }

  ensureAvailablePlanSelection() {
    if (!this.planOptionButtons.length) return;

    const activeButton = this.getSelectedPlanButton();
    const activeIsAvailable = this.isPlanButtonAvailable(activeButton);

    if (activeIsAvailable) return;

    const fallbackButton = this.planOptionButtons.find((button) => this.isPlanButtonAvailable(button)) || null;

    this.planOptionButtons.forEach((button) => {
      const isActive = Boolean(fallbackButton) && button === fallbackButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  getCurrentPricing() {
    const allocation = this.getSellingPlanAllocation();
    const cartridgeVariant = this.getCartridgeVariantData();

    if (this.hasPlanSelector() && !allocation) {
      return {
        priceCents: 0,
        compareAtPriceCents: 0,
        priceHtml: '',
        compareAtPriceHtml: '',
      };
    }

    const variantPrice = Number(cartridgeVariant?.price || 0);
    const variantCompareAtPrice = Number(cartridgeVariant?.compare_at_price || 0);
    const priceCents = Number(allocation?.price ?? variantPrice);
    const compareAtPriceCents = Number(allocation?.compare_at_price ?? variantCompareAtPrice);
    const fallbackCompareHtml =
      compareAtPriceCents > priceCents ? this.formatMoney(compareAtPriceCents) : '';

    return {
      priceCents,
      compareAtPriceCents,
      priceHtml: allocation?.price_html || cartridgeVariant?.price_html || this.formatMoney(priceCents),
      compareAtPriceHtml:
        allocation?.compare_at_price_html || cartridgeVariant?.compare_at_price_html || fallbackCompareHtml,
    };
  }

  syncPriceOutputs() {
    const pricing = this.getCurrentPricing();
    const shouldShowCompare = Boolean(pricing.compareAtPriceHtml) && pricing.compareAtPriceCents > pricing.priceCents;

    this.priceCurrentOutputs.forEach((output) => {
      output.textContent = pricing.priceHtml || '';
    });

    this.priceCompareOutputs.forEach((output) => {
      output.textContent = shouldShowCompare ? pricing.compareAtPriceHtml : '';
      output.hidden = !shouldShowCompare;
    });
  }

  getVisualDiscountTiers() {
    const source = this.buyButtonsBlock?.dataset || {};

    return [
      {
        minQuantity: parseInt(source.visualDiscountTier1MinQuantity || '1', 10),
        percent: parseInt(source.visualDiscountTier1Percent || '12', 10),
      },
      {
        minQuantity: parseInt(source.visualDiscountTier2MinQuantity || '2', 10),
        percent: parseInt(source.visualDiscountTier2Percent || '20', 10),
      },
      {
        minQuantity: parseInt(source.visualDiscountTier3MinQuantity || '4', 10),
        percent: parseInt(source.visualDiscountTier3Percent || '28', 10),
      },
      {
        minQuantity: parseInt(source.visualDiscountTier4MinQuantity || '8', 10),
        percent: parseInt(source.visualDiscountTier4Percent || '36', 10),
      },
    ]
      .filter(({ minQuantity, percent }) => {
        return Number.isFinite(minQuantity) && minQuantity > 0 && Number.isFinite(percent) && percent > 0;
      })
      .sort((left, right) => right.minQuantity - left.minQuantity);
  }

  getVisualDiscountPercent(quantity) {
    const matchedTier = this.getVisualDiscountTiers().find(({ minQuantity }) => quantity >= minQuantity);
    return matchedTier?.percent || 0;
  }

  getVisualDiscountLabel(percent) {
    const label = this.buyButtonsBlock?.dataset.visualDiscountLabel || 'Save';
    return `${label} ${percent}%`.trim();
  }

  isVisualDiscountVisibleForPlanCard(button) {
    return button instanceof HTMLElement && button.dataset.visualDiscountEnabled === 'true';
  }

  getDiscountedUnitPriceCents(unitPriceCents, percent) {
    const normalizedPrice = Number(unitPriceCents);
    const normalizedPercent = Math.min(Math.max(Number(percent) || 0, 0), 100);

    if (!Number.isFinite(normalizedPrice) || normalizedPrice <= 0 || normalizedPercent <= 0) {
      return Number.isFinite(normalizedPrice) ? normalizedPrice : 0;
    }

    // Cart discounts round the per-unit discount down, so the displayed unit price must round up.
    return Math.ceil((normalizedPrice * (100 - normalizedPercent)) / 100);
  }

  getDiscountedLinePriceCents(unitPriceCents, quantity, percent) {
    const normalizedQuantity = Math.max(parseInt(quantity || '0', 10) || 0, 0);

    if (normalizedQuantity <= 0) return 0;

    return this.getDiscountedUnitPriceCents(unitPriceCents, percent) * normalizedQuantity;
  }

  syncBuyWidgetUI() {
    this.ensureAvailablePlanSelection();

    const pricing = this.getCurrentPricing();
    const quantity = this.getQuantity();
    const hasValidSellingPlan = this.hasValidSellingPlanSelection();
    const selectedPlanButton = this.getSelectedPlanButton();
    const selectedPlanSummary = selectedPlanButton?.dataset.planSummaryLabel || '';
    const cartridgeLabel =
      this.summaryCartridgeLine instanceof HTMLElement
        ? this.summaryCartridgeLine.dataset.summaryCartridgeLabel || ''
        : '';
    const baseLinePriceCents = hasValidSellingPlan ? pricing.priceCents * quantity : 0;
    const discountPercent = hasValidSellingPlan ? this.getVisualDiscountPercent(quantity) : 0;
    const linePriceCents = hasValidSellingPlan
      ? this.getDiscountedLinePriceCents(pricing.priceCents, quantity, discountPercent)
      : 0;
    const nativeCompareLinePriceCents =
      hasValidSellingPlan && pricing.compareAtPriceCents > pricing.priceCents
        ? pricing.compareAtPriceCents * quantity
        : 0;
    const compareLinePriceCents =
      discountPercent > 0 ? Math.max(baseLinePriceCents, nativeCompareLinePriceCents) : nativeCompareLinePriceCents;

    if (this.quantityInput instanceof HTMLInputElement) {
      this.quantityInput.value = String(quantity);
    }

    this.currentSellingPlanInputs.forEach((input) => {
      if (input instanceof HTMLInputElement) {
        input.value = this.getValidatedSellingPlanId();
      }
    });

    this.planOptionButtons.forEach((button) => {
      const sellingPlanId = (button.dataset.sellingPlanId || '').trim();
      const allocation = this.getSellingPlanAllocation(sellingPlanId);
      const isAvailable = Boolean(sellingPlanId && allocation);
      const priceOutput = button.querySelector('[data-pdp-plan-price]');
      const discountOutput = button.querySelector('[data-pdp-plan-discount]');
      const badgeOutput = button.querySelector('.pdp-main-product-new-page__choice-badge');
      const suffix = button.dataset.planPriceSuffix || '';
      const planPrice = allocation?.price;
      const planQuantity = this.getHouseholdQuantity() * this.getPlanCartridgeMultiplier(button);
      const planDiscountPercent =
        isAvailable && this.isVisualDiscountVisibleForPlanCard(button) ? this.getVisualDiscountPercent(planQuantity) : 0;

      button.disabled = this.isBusy || !isAvailable;
      button.classList.toggle('is-unavailable', !isAvailable);

      if (priceOutput instanceof HTMLElement) {
        priceOutput.textContent =
          isAvailable && Number.isFinite(Number(planPrice))
            ? `${this.formatMoney(Number(planPrice))} ${suffix}`.trim()
            : 'Unavailable';
      }

      if (badgeOutput instanceof HTMLElement) {
        if (!badgeOutput.dataset.staticText) {
          badgeOutput.dataset.staticText = badgeOutput.textContent || '';
        }

        const staticText = badgeOutput.dataset.staticText || '';
        badgeOutput.textContent = planDiscountPercent > 0 ? this.getVisualDiscountLabel(planDiscountPercent) : staticText;
        badgeOutput.hidden = planDiscountPercent <= 0 && !staticText;
      }

      if (discountOutput instanceof HTMLElement) {
        const hasBadge = badgeOutput instanceof HTMLElement;
        discountOutput.textContent = planDiscountPercent > 0 ? this.getVisualDiscountLabel(planDiscountPercent) : '';
        discountOutput.hidden = hasBadge || planDiscountPercent <= 0;
      }
    });

    if (this.summaryCartridgeLine instanceof HTMLElement) {
      const planFragment = selectedPlanSummary ? ` (${selectedPlanSummary})` : '';
      this.summaryCartridgeLine.textContent = `${quantity}x ${cartridgeLabel}${planFragment}`.trim();
    }

    if (this.summaryCartridgePrice instanceof HTMLElement) {
      this.summaryCartridgePrice.textContent = hasValidSellingPlan ? this.formatMoney(linePriceCents) : '';
    }

    if (this.summaryDiscount instanceof HTMLElement) {
      this.summaryDiscount.textContent = discountPercent > 0 ? this.getVisualDiscountLabel(discountPercent) : '';
      this.summaryDiscount.hidden = discountPercent <= 0;
    }

    if (this.summaryTotalPrice instanceof HTMLElement) {
      this.summaryTotalPrice.textContent = hasValidSellingPlan ? this.formatMoney(linePriceCents) : '';
    }

    if (this.summaryTotalCompare instanceof HTMLElement) {
      const shouldShowCompare = compareLinePriceCents > linePriceCents;
      this.summaryTotalCompare.textContent = shouldShowCompare ? this.formatMoney(compareLinePriceCents) : '';
      this.summaryTotalCompare.hidden = !shouldShowCompare;
    }
  }

  formatMoney(cents) {
    const value = (Number.isFinite(cents) ? cents : 0) / 100;
    const currency = this.dataset.currencyCode || 'USD';
    const locale = this.dataset.locale || document.documentElement.lang || undefined;
    const currencyDisplay = this.dataset.showCurrencyCode === 'true' ? 'code' : 'symbol';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (error) {
      return `${value.toFixed(2)}${currencyDisplay === 'code' ? ` ${currency}` : ''}`;
    }
  }

  getSelectedAddons() {
    return this.addonItems
      .map((item) => {
        if (!(item instanceof HTMLElement)) return null;

        const checkbox = item.querySelector('[data-addon-toggle]');
        const input = item.querySelector('[data-addon-quantity-input]');
        const variantId = parseInt(item.dataset.addonVariantId || '', 10);
        const available = item.dataset.addonAvailable === 'true';

        if (
          !(checkbox instanceof HTMLInputElement) ||
          !(input instanceof HTMLInputElement) ||
          Number.isNaN(variantId) ||
          !available ||
          !checkbox.checked
        ) {
          return null;
        }

        return {
          id: variantId,
          quantity: this.getNormalizedQuantityValue(input),
          linked: this.isLinkedAddonVariant(variantId),
        };
      })
      .filter(Boolean);
  }

  syncAddonsUI() {
    this.addonItems.forEach((item) => {
      if (!(item instanceof HTMLElement)) return;

      const checkbox = item.querySelector('[data-addon-toggle]');
      const input = item.querySelector('[data-addon-quantity-input]');
      const decreaseButton = item.querySelector('[data-addon-quantity-decrease]');
      const increaseButton = item.querySelector('[data-addon-quantity-increase]');
      const chooseButton = item.querySelector('[data-addon-open-modal]');
      const available = item.dataset.addonAvailable === 'true';
      if (checkbox instanceof HTMLInputElement) {
        checkbox.disabled = this.isBusy || !available;
        if (!available && checkbox.checked) {
          checkbox.checked = false;
        }
      }

      const selected = available && checkbox instanceof HTMLInputElement && checkbox.checked;
      const controlsDisabled = this.isBusy || !available || !selected;

      item.classList.toggle('is-selected', selected);
      item.classList.toggle('is-unavailable', !available);

      if (chooseButton instanceof HTMLButtonElement) {
        chooseButton.disabled = this.isBusy;
      }

      if (input instanceof HTMLInputElement) {
        input.value = String(this.getNormalizedQuantityValue(input));
        input.disabled = controlsDisabled;
      }

      if (decreaseButton instanceof HTMLButtonElement) {
        decreaseButton.disabled =
          controlsDisabled || !(input instanceof HTMLInputElement) || this.getNormalizedQuantityValue(input) <= 1;
      }

      if (increaseButton instanceof HTMLButtonElement) {
        increaseButton.disabled = controlsDisabled;
      }
    });

    const activeAddonVariant = this.getSelectedAddonVariant();
    if (this.addonModalApplyButton instanceof HTMLButtonElement && this.addonModal && !this.addonModal.hidden) {
      this.addonModalApplyButton.disabled = this.isBusy || !activeAddonVariant || !activeAddonVariant.available;
    }

    this.updateAddonShowMoreButtons();
  }

  updateAddonShowMoreButtons() {
    this.addonShowMoreButtons.forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;

      const block = button.closest('[data-addons-block]');
      if (!(block instanceof HTMLElement)) return;

      const collapsibleItems = Array.from(block.querySelectorAll('[data-addon-collapsible="true"]'));
      const hiddenItemsCount = collapsibleItems.filter(
        (item) => item instanceof HTMLElement && item.hidden
      ).length;
      const isExpanded = block.classList.contains('is-expanded');
      const collapsedLabel = button.dataset.collapsedLabel || button.textContent || '';
      const expandedLabel = button.dataset.expandedLabel || button.textContent || '';

      if (!collapsibleItems.length) {
        button.hidden = true;
        return;
      }

      button.hidden = false;
      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

      if (isExpanded) {
        button.textContent = expandedLabel;
        return;
      }

      if (hiddenItemsCount <= 0) {
        button.hidden = true;
        return;
      }

      if (collapsedLabel.includes('{count}')) {
        button.textContent = collapsedLabel.replace('{count}', String(hiddenItemsCount));
        return;
      }

      button.textContent = `${collapsedLabel} ${hiddenItemsCount}`.trim();
    });
  }

  hasSelectableAddonOptions(product) {
    if (!product?.options?.length) return false;
    if (product.options.length !== 1) return true;

    const option = product.options[0];
    return !(option.values.length === 1 && option.values[0] === 'Default Title');
  }

  getInitialAddonSelections(product) {
    const selectedVariant =
      product.variants.find((variant) => variant.id === product.selected_variant_id && variant.available) ||
      product.variants.find((variant) => variant.available) ||
      product.variants[0] ||
      null;

    return Array.isArray(selectedVariant?.options) ? [...selectedVariant.options] : [];
  }

  getSelectedAddonVariant() {
    if (!this.activeAddonProduct) return null;

    return (
      this.activeAddonProduct.variants.find((variant) =>
        variant.options.every((value, index) => value === this.activeAddonSelections[index])
      ) || null
    );
  }

  isAddonOptionValueAvailable(optionIndex, value) {
    if (!this.activeAddonProduct) return false;

    return this.activeAddonProduct.variants.some((variant) => {
      if (!variant.available) return false;

      return variant.options.every((variantValue, index) => {
        if (index === optionIndex) return variantValue === value;
        return variantValue === this.activeAddonSelections[index];
      });
    });
  }

  renderAddonModal() {
    const product = this.activeAddonProduct;
    if (!product) return;

    const variant = this.getSelectedAddonVariant() || product.variants.find((item) => item.available) || product.variants[0] || null;
    const image = variant?.image || product.featured_image || null;

    if (Array.isArray(variant?.options)) {
      this.activeAddonSelections = [...variant.options];
    }

    if (this.addonModalTitle) {
      this.addonModalTitle.textContent = product.title || '';
    }

    if (this.addonModalImage instanceof HTMLImageElement) {
      this.addonModalImage.src = image?.src || '';
      this.addonModalImage.alt = image?.alt || product.title || '';
    }

    if (this.addonModalPrice) {
      this.addonModalPrice.textContent = variant?.discounted_price_text || variant?.price_text || '';
    }

    if (this.addonModalComparePrice) {
      const comparePrice = variant?.compare_price_text || '';
      this.addonModalComparePrice.textContent = comparePrice;
      this.addonModalComparePrice.hidden = !comparePrice;
    }

    if (this.addonModalDiscountBadge instanceof HTMLElement) {
      const discountPercentage = Number(variant?.discount_percentage ?? product.discount_percentage ?? 0);
      const hasDiscountSource = variant?.has_discount ?? product.has_discount;
      const hasDiscount = hasDiscountSource === true && discountPercentage > 0;

      this.addonModalDiscountBadge.textContent = hasDiscount ? `-${discountPercentage}%` : '';
      this.addonModalDiscountBadge.hidden = !hasDiscount;
    }

    if (this.addonModalOptions) {
      this.addonModalOptions.innerHTML = product.options
        .map((option, index) => {
          const selectedValue = this.activeAddonSelections[index] || option.values[0] || '';
          const valuesMarkup = option.values
            .map((value) => {
              const isSelected = value === selectedValue;
              const isAvailable = this.isAddonOptionValueAvailable(index, value);

              return `
                <button
                  class="pdp-main-product-new-page__addon-modal-option-button${isSelected ? ' is-selected' : ''}${isAvailable ? '' : ' is-unavailable'}"
                  type="button"
                  data-addon-option-index="${index}"
                  data-addon-option-value="${this.escapeHtml(value)}"
                  ${isAvailable ? '' : 'aria-disabled="true"'}
                >
                  ${this.escapeHtml(value)}
                </button>
              `;
            })
            .join('');

          return `
            <div class="pdp-main-product-new-page__addon-modal-option-group">
              <div class="pdp-main-product-new-page__addon-modal-option-label">
                ${this.escapeHtml(option.name)}: <strong>${this.escapeHtml(selectedValue)}</strong>
              </div>
              <div class="pdp-main-product-new-page__addon-modal-option-values">
                ${valuesMarkup}
              </div>
            </div>
          `;
        })
        .join('');
    }

    if (this.addonModalApplyButton instanceof HTMLButtonElement) {
      this.addonModalApplyButton.disabled = this.isBusy || !variant || !variant.available;
    }

    this.clearAddonModalError();
  }

  applyAddonVariantToItem(item, product, variant) {
    if (!(item instanceof HTMLElement) || !product || !variant) return;

    const checkbox = item.querySelector('[data-addon-toggle]');
    const subtitle = item.querySelector('[data-addon-subtitle]');
    const price = item.querySelector('[data-addon-price]');
    const comparePrice = item.querySelector('[data-addon-compare-price]');
    const discountBadge = item.querySelector('[data-addon-discount-badge]');
    const image = item.querySelector('[data-addon-image]');
    const stock = item.querySelector('[data-addon-stock]');
    const chooseButton = item.querySelector('[data-addon-open-modal]');

    item.dataset.addonVariantId = String(variant.id);
    item.dataset.addonAvailable = String(Boolean(variant.available));

    product.selected_variant_id = variant.id;

    if (subtitle instanceof HTMLElement) {
      const nextSubtitle = variant.title && variant.title !== 'Default Title' ? variant.title : '';
      subtitle.textContent = nextSubtitle;
      subtitle.hidden = !nextSubtitle;
    }

    if (price instanceof HTMLElement) {
      price.textContent = variant.discounted_price_text || variant.price_text || '';
    }

    if (comparePrice instanceof HTMLElement) {
      const nextComparePrice = variant.compare_price_text || '';
      comparePrice.textContent = nextComparePrice;
      comparePrice.hidden = !nextComparePrice;
    }

    if (discountBadge instanceof HTMLElement) {
      const discountPercentage = Number(variant?.discount_percentage ?? product.discount_percentage ?? 0);
      const hasDiscountSource = variant?.has_discount ?? product.has_discount;
      const hasDiscount = hasDiscountSource === true && discountPercentage > 0;

      discountBadge.textContent = hasDiscount ? `-${discountPercentage}%` : '';
      discountBadge.hidden = !hasDiscount;
    }

    if (image instanceof HTMLImageElement) {
      const nextImage = variant.image || product.featured_image || null;
      if (nextImage?.src) {
        image.src = nextImage.src;
        image.alt = nextImage.alt || product.title || '';
      }
    }

    if (stock instanceof HTMLElement) {
      stock.hidden = Boolean(variant.available);
    }

    if (checkbox instanceof HTMLInputElement && !variant.available) {
      checkbox.checked = false;
    }

    if (chooseButton instanceof HTMLButtonElement) {
      chooseButton.disabled = this.isBusy;
    }
  }

  openSizeGuideModal() {
    if (!(this.sizeGuideModal instanceof HTMLElement)) return;

    this.previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.sizeGuideModal.hidden = false;
    this.sizeGuideModalPanel?.focus();
  }

  closeSizeGuideModal() {
    if (!(this.sizeGuideModal instanceof HTMLElement)) return;

    this.sizeGuideModal.hidden = true;
    document.body.style.overflow = this.previousBodyOverflow || '';
    this.activeSizeGuideTrigger?.focus();
    this.activeSizeGuideTrigger = null;
  }

  openAddonModal() {
    if (!(this.addonModal instanceof HTMLElement)) return;

    this.previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.addonModal.hidden = false;
    this.addonModalPanel?.focus();
  }

  closeAddonModal() {
    if (!(this.addonModal instanceof HTMLElement)) return;

    this.addonModal.hidden = true;
    document.body.style.overflow = this.previousBodyOverflow || '';
    this.activeAddonTrigger?.focus();
    this.activeAddonTrigger = null;
    this.activeAddonItem = null;
    this.activeAddonProduct = null;
    this.activeAddonSelections = [];
    this.clearAddonModalError();
  }

  syncPurchaseUI() {
    this.ensureAvailablePlanSelection();

    const mainOfferVariant = this.getMainOfferVariantData();
    const cartridgeVariant = this.getCartridgeVariantData();
    const isAvailable = Boolean(mainOfferVariant?.id && mainOfferVariant.available && cartridgeVariant?.id && cartridgeVariant.available);
    const hasValidSellingPlan = this.hasValidSellingPlanSelection();
    const disabled = !isAvailable || this.isBusy || !hasValidSellingPlan;

    if (this.addToCartButton instanceof HTMLButtonElement) {
      this.addToCartButton.disabled = disabled;
    }

    if (this.buyNowButton instanceof HTMLButtonElement) {
      this.buyNowButton.disabled = disabled;
    }

    if (this.quantityInput instanceof HTMLInputElement) {
      this.quantityInput.disabled = this.isBusy;
    }

    if (this.quantityDecreaseButton instanceof HTMLButtonElement) {
      this.quantityDecreaseButton.disabled = this.isBusy || this.getQuantity() <= 1;
    }

    if (this.quantityIncreaseButton instanceof HTMLButtonElement) {
      this.quantityIncreaseButton.disabled = this.isBusy;
    }

    this.householdOptionButtons.forEach((button) => {
      button.disabled = this.isBusy;
    });

    this.syncPriceOutputs();
    this.syncBuyWidgetUI();
    this.syncProductFormInputs({ dispatchChange: true });
    this.syncAddonsUI();
    this.syncStickyBar();
  }

  syncStickyBar() {
    if (!(this.stickyBar instanceof HTMLElement)) return;

    const pricing = this.getCurrentPricing();

    if (this.stickyPriceCurrentOutput instanceof HTMLElement) {
      this.stickyPriceCurrentOutput.textContent = pricing.priceHtml || '';
    }

    if (this.stickyPriceCompareOutput instanceof HTMLElement) {
      const comparePrice = pricing.compareAtPriceHtml || '';
      const shouldShowComparePrice = Boolean(comparePrice) && pricing.compareAtPriceCents > pricing.priceCents;

      this.stickyPriceCompareOutput.textContent = comparePrice;
      this.stickyPriceCompareOutput.hidden = !shouldShowComparePrice;
    }

    if (this.stickyVariantOutput instanceof HTMLElement) {
      const variantTitle = this.currentVariant?.title || '';
      const shouldShowVariantTitle =
        variantTitle !== '' && variantTitle !== 'Default Title' && this.variants.length > 1;

      this.stickyVariantOutput.textContent = shouldShowVariantTitle ? variantTitle : '';
      this.stickyVariantOutput.hidden = !shouldShowVariantTitle;
    }

    if (this.stickyAddToCartButton instanceof HTMLButtonElement) {
      const mainOfferVariant = this.getMainOfferVariantData();
      const cartridgeVariant = this.getCartridgeVariantData();
      this.stickyAddToCartButton.disabled =
        this.isBusy ||
        !mainOfferVariant?.available ||
        !cartridgeVariant?.available ||
        !this.hasValidSellingPlanSelection();
    }

    if (this.stickyImage instanceof HTMLImageElement) {
      const imageData = this.getStickyImageData();

      if (imageData) {
        this.stickyImage.src = imageData.src;
        this.stickyImage.alt = imageData.alt;

        if (this.stickyMedia instanceof HTMLElement) {
          this.stickyMedia.hidden = false;
        }
      } else if (this.stickyMedia instanceof HTMLElement) {
        this.stickyMedia.hidden = true;
      }
    }
  }

  syncProductFormInputs({ dispatchChange = false } = {}) {
    const variantValue = this.currentVariantId ? String(this.currentVariantId) : '';
    const quantityValue = String(this.getQuantity());
    const isAvailable = Boolean(
      this.getMainOfferVariantData()?.available && this.getCartridgeVariantData()?.available
    );

    this.currentVariantInputs.forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;

      const hasChanged = input.value !== variantValue;
      input.value = variantValue;

      if (dispatchChange && hasChanged) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    this.currentQuantityInputs.forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;

      const hasChanged = input.value !== quantityValue;
      input.value = quantityValue;

      if (dispatchChange && hasChanged) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    this.paymentTermsRegions.forEach((region) => {
      if (!(region instanceof HTMLElement)) return;
      region.hidden = !isAvailable;
    });
  }

  showStickyBar() {
    if (!(this.stickyBar instanceof HTMLElement)) return;
    this.stickyBar.dataset.stuck = 'true';
  }

  hideStickyBar() {
    if (!(this.stickyBar instanceof HTMLElement)) return;
    this.stickyBar.dataset.stuck = 'false';
  }

  getStickyImageData() {
    const selectors = [];
    const featuredMediaId = Number.parseInt(this.currentVariant?.featured_media_id || '', 10);

    if (!Number.isNaN(featuredMediaId)) {
      selectors.push(
        `[data-gallery-slide][data-media-id="${featuredMediaId}"] .pdp-main-product-new-page__gallery-image`,
        `[data-gallery-thumb][data-media-id="${featuredMediaId}"] .pdp-main-product-new-page__gallery-thumb-image`
      );
    }

    selectors.push('.pdp-main-product-new-page__gallery-image', '.pdp-main-product-new-page__gallery-thumb-image');

    for (const selector of selectors) {
      const image = this.querySelector(selector);

      if (image instanceof HTMLImageElement && image.src) {
        return {
          src: image.currentSrc || image.src,
          alt: image.alt || this.dataset.productTitle || '',
        };
      }
    }

    return null;
  }

  isLinkedAddonVariant(variantId) {
    return this.linkedAddonVariantIds instanceof Set && this.linkedAddonVariantIds.has(String(variantId));
  }

  buildLinkedAddonProperties({ group, role, removeLinkedRoles = [] }) {
    const properties = {
      _offer_source: 'pdp-main-product-new-page-addons',
      _offer_group: group,
      _offer_role: role,
    };

    if (removeLinkedRoles.length > 0) {
      properties._offer_remove_linked_roles = removeLinkedRoles.join(',');
    }

    return properties;
  }

  buildBuyWidgetOfferProperties({ group, role, removeLinkedRoles = [] }) {
    const properties = {
      _offer_source: 'pdp-main-product-new-page',
      _offer_group: group,
      _offer_role: role,
      _offer_lock_quantity: 'true',
    };

    if (removeLinkedRoles.length > 0) {
      properties._offer_remove_linked_roles = removeLinkedRoles.join(',');
    }

    return properties;
  }

  createLinkedAddonGroupId() {
    if (window.crypto?.randomUUID) return `pdp-addon-${window.crypto.randomUUID()}`;
    return `pdp-addon-${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
  }

  async addCurrentVariant({ redirectToCheckout }) {
    if (this.isBusy) return;

    const mainOfferVariant = this.getMainOfferVariantData();
    const cartridgeVariant = this.getCartridgeVariantData();

    if (!mainOfferVariant?.id || !mainOfferVariant.available || !cartridgeVariant?.id || !cartridgeVariant.available) {
      this.showError(this.getUnavailableText());
      return;
    }

    const sellingPlanId = this.getValidatedSellingPlanId();

    if (this.hasPlanSelector() && !sellingPlanId) {
      this.showError(this.getSellingPlanErrorText());
      return;
    }

    this.clearError();
    this.isBusy = true;
    this.syncPurchaseUI();

    const quantity = this.getQuantity();
    const route = this.getCartAddUrl();
    const selectedAddons = this.getSelectedAddons();
    const offerGroupId = this.createLinkedAddonGroupId();
    const items = [
      {
        id: Number(mainOfferVariant.id),
        quantity: 1,
        properties: this.buildBuyWidgetOfferProperties({
          group: offerGroupId,
          role: 'main',
          removeLinkedRoles: ['addon'],
        }),
      },
      {
        id: Number(cartridgeVariant.id),
        quantity,
        ...(sellingPlanId ? { selling_plan: sellingPlanId } : {}),
        properties: this.buildBuyWidgetOfferProperties({
          group: offerGroupId,
          role: 'addon',
          removeLinkedRoles: ['main'],
        }),
      },
      ...selectedAddons.map((addon) => {
        const item = {
          id: addon.id,
          quantity: addon.quantity,
        };

        if (addon.linked && offerGroupId) {
          item.properties = this.buildLinkedAddonProperties({
            group: offerGroupId,
            role: 'addon',
          });
        }

        return item;
      }),
    ];
    const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((item) => item.getAttribute('data-section-id') || '')
      .filter(Boolean);
    const requestBody = { items };

    if (sectionIds.length > 0) {
      requestBody.sections = sectionIds.join(',');
      requestBody.sections_url = window.location.pathname;
    }

    try {
      const response = await fetch(route, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || this.getUnavailableText());
      }

      this.dispatchCartUpdate(data, totalQuantity);

      if (redirectToCheckout) {
        window.location.href = this.dataset.buyNowUrl || '/checkout';
      } else {
        this.openCartDrawer();
      }
    } catch (error) {
      console.error(error);
      this.showError(error instanceof Error ? error.message : this.getUnavailableText());
    } finally {
      this.isBusy = false;
      this.syncPurchaseUI();
    }
  }

  dispatchCartUpdate(resource, quantity) {
    this.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource,
          sourceId: this.id,
          data: {
            source: 'pdp-main-product-new-page',
            itemCount: quantity,
            variantId: String(this.getMainOfferVariantData()?.id || this.currentVariantId || ''),
            sections: resource.sections || {},
          },
        },
      })
    );
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!(cartDrawer instanceof HTMLElement)) return;

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    if (typeof cartDrawer.showDialog === 'function') {
      cartDrawer.showDialog();
    }
  }

  getCartAddUrl() {
    return this.dataset.routeCartAdd || window.Theme?.routes?.cart_add_url || '/cart/add';
  }

  getUnavailableText() {
    return this.buyButtonsBlock?.dataset.unavailableText || 'This variant is currently unavailable.';
  }

  getSellingPlanErrorText() {
    return this.buyButtonsBlock?.dataset.sellingPlanErrorText || 'Select a valid subscription plan.';
  }

  showError(message) {
    if (!(this.errorRegion instanceof HTMLElement)) return;

    this.errorRegion.hidden = false;
    this.errorRegion.textContent = message;
  }

  clearError() {
    if (!(this.errorRegion instanceof HTMLElement)) return;

    this.errorRegion.hidden = true;
    this.errorRegion.textContent = '';
  }

  handleWindowKeydown(event) {
    if (event.key !== 'Escape') return;

    if (this.sizeGuideModal instanceof HTMLElement && !this.sizeGuideModal.hidden) {
      this.closeSizeGuideModal();
      return;
    }

    if (this.addonModal instanceof HTMLElement && !this.addonModal.hidden) {
      this.closeAddonModal();
    }
  }

  showAddonModalError(message) {
    if (!(this.addonModalError instanceof HTMLElement)) return;

    this.addonModalError.hidden = false;
    this.addonModalError.textContent = message;
  }

  clearAddonModalError() {
    if (!(this.addonModalError instanceof HTMLElement)) return;

    this.addonModalError.hidden = true;
    this.addonModalError.textContent = '';
  }

  escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }
}

if (!customElements.get('pdp-main-product-new-page')) {
  customElements.define('pdp-main-product-new-page', PdpMainProductNewPage);
}
